import { render, staticRenderFns } from "./IframePage.vue?vue&type=template&id=377cdf53&scoped=true"
import script from "./IframePage.vue?vue&type=script&lang=js"
export * from "./IframePage.vue?vue&type=script&lang=js"
import style0 from "./IframePage.vue?vue&type=style&index=0&id=377cdf53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377cdf53",
  null
  
)

export default component.exports